import img1 from '@/assets/images/IBON-World-Launch-6.jpeg'
import img2 from '@/assets/images/leaders-group.jpeg'
import img3 from '@/assets/images/networking-desk.jpeg'
import img4 from '@/assets/images/registration-signing.jpeg'
import img5 from '@/assets/images/team-registration.jpeg'
import img6 from '@/assets/images/IBON-World-Launch-14.jpeg'
import img7 from '@/assets/images/culture-music.jpeg'
import img8 from '@/assets/images/culture-chiefs.jpeg'
import img9 from '@/assets/images/IBON-World-Launch-37.jpeg'
import img10 from '@/assets/images/IBON-World-Launch-5.jpeg'
import img11 from '@/assets/images/IBON-World-Launch-27.jpeg'
import img12 from '@/assets/images/magazine-feature.jpeg'
import type { Shot } from '@/types/gallery'

export const categories = ['All', 'Conferences', 'Training', 'Cultural', 'Events'] as const

export const shots: Shot[] = [
  { src: img1, caption: 'IBON World Launch', category: 'Conferences', span: true },
  { src: img2, caption: 'Leadership Roundtable', category: 'Conferences' },
  { src: img3, caption: 'Networking Session', category: 'Conferences' },
  { src: img4, caption: 'Partnership Signing', category: 'Training' },
  { src: img5, caption: 'Programme Registration', category: 'Training' },
  { src: img6, caption: 'Capacity Workshop', category: 'Training', span: true },
  { src: img7, caption: 'Cultural Performance', category: 'Cultural', span: true },
  { src: img8, caption: 'Traditional Leaders', category: 'Cultural' },
  { src: img9, caption: 'Heritage Showcase', category: 'Cultural' },
  { src: img10, caption: 'Opening Ceremony', category: 'Events' },
  { src: img11, caption: 'Community Gathering', category: 'Events', span: true },
  { src: img12, caption: 'Magazine Feature', category: 'Events' },
]
